import { render, staticRenderFns } from "./wcenter.vue?vue&type=template&id=f77b9950&scoped=true&"
import script from "./wcenter.vue?vue&type=script&lang=js&"
export * from "./wcenter.vue?vue&type=script&lang=js&"
import style0 from "./wcenter.vue?vue&type=style&index=0&id=f77b9950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77b9950",
  null
  
)

export default component.exports